import React, { useEffect } from "react";
import { useDrag } from "react-dnd";

export const GenesisListComponent =
  // React.memo(
  React.forwardRef(
    (
      {
        gender,
        image,
        owner,
        token_id,
        txdate,
        isDroppedCard,
        activeToken,
        genesisInfo,
        handleInitialChange,
        handleCardChange,
        ...rest
      },
      ref
    ) => {
      useEffect(() => {
        handleInitialChange({ gender, image, txdate, token_id });
      }, []);

      // const [{ opacity }, drag] = useDrag(
      //   () => ({
      //     type: gender,
      //     item: { gender, image, owner, token_id, txdate },
      //     collect: (monitor) => ({
      //       opacity: monitor.isDragging ? 0.1 : 1,
      //     }),
      //   }),
      //   [token_id, gender]
      // );

      const manageThisActive = () => {
        if (
          parseInt(genesisInfo.genesis[genesisInfo.activeIndex].token_id) !==
          parseInt(token_id)
        ) {
          handleCardChange({ gender, image, txdate, token_id });
        }
      };

      return (
        <>
          <div
            // ref={drag}
            data-testid="genesis_list"
            data-active={genesisInfo.genesis[genesisInfo.activeIndex].token_id}
            data-token={parseInt(token_id)}
            className={
              "genesis-list" +
              (parseInt(
                genesisInfo.genesis[genesisInfo.activeIndex].token_id
              ) == parseInt(token_id)
                ? " active"
                : "")
            }
            onClick={manageThisActive}
            // style={{opacity }}
          >
            <i className="bi bi-check-circle-fill"></i>
            <img src={image} className="img-fluid" />
            {/* {isDroppedCard ? <s>{name}</s> : name} */}
          </div>
        </>
      );
    }
    // )
  );
